/**
 * After a workspace-mismatch release, do not put that thread back because
 * URL sync flickered the sidebar filter. Cleared when the user opens the thread.
 */

const suppressedThreadIds = new Set<string>()

const AUTOMATIC_RESTORE_REASONS = new Set([
  'workspace-overlap',
  'mount-empty',
  'focus-empty',
  'welcome-composer',
  'welcome-composer-retry',
])

export function suppressAgentPanelAutoRestore(threadId: string | null | undefined): void {
  if (!threadId || threadId.startsWith('new-')) return
  suppressedThreadIds.add(threadId)
}

export function clearAgentPanelAutoRestoreSuppress(threadId?: string): void {
  if (!threadId) {
    suppressedThreadIds.clear()
    return
  }
  suppressedThreadIds.delete(threadId)
}

export function isAgentPanelAutoRestoreSuppressed(threadId: string | null | undefined): boolean {
  if (!threadId) return false
  return suppressedThreadIds.has(threadId)
}

export function isAutomaticAgentPanelRestoreReason(reason: string): boolean {
  const base = reason.replace(/-after-meta$/, '')
  return AUTOMATIC_RESTORE_REASONS.has(base)
}

/** Automatic restore (filter flicker, mount, focus) must not revive a mismatch-released thread. */
export function shouldBlockSuppressedAutoRestore(
  reason: string,
  storedThreadId: string | null | undefined,
): boolean {
  if (!storedThreadId || !isAutomaticAgentPanelRestoreReason(reason)) return false
  return isAgentPanelAutoRestoreSuppressed(storedThreadId)
}

/** Test-only reset. */
export function __resetAgentPanelAutoRestoreSuppressForTests(): void {
  suppressedThreadIds.clear()
}
